import React from "react"
import {
  Col,
  Drawer,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Upload,
  notification,
} from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { Button } from "src/components/actions/button"
import { CloseSvg, SaveSvg } from "src/components/Svg"
import { useAppData } from "src/store/app-data"
import api from "src/api"
import styled from "styled-components"

export function CreateDistributionDrawer({ onClose, onSuccess }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)
  const [form] = Form.useForm()
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  async function onSubmit(values) {
    setIsSubmitting(true)
    try {
      const formData = new FormData()
      formData.append("title", values.title)
      formData.append("lookup_type", values.lookup_type)
      formData.append("amount", String(values.amount))
      formData.append("file", values.file.file)

      await api.post("bonus-distributions", formData, {
        useV2Api: true,
        headers: { "Content-Type": "multipart/form-data" },
      })

      notification.success({ message: "Рассылка создана и запущена" })
      form.resetFields()
      onSuccess()
    } catch (error) {
      console.error("Ошибка создания", error)
      notification.error({ message: "Ошибка создания рассылки" })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <DrawerEdit
      width={layoutConfig.isMobile ? "90%" : "50%"}
      title="Новая рассылка баллов"
      onClose={onClose}
      open
    >
      <FormEdit form={form} layout="vertical" onFinish={onSubmit}>
        <StyledFormItem
          label="Название"
          name="title"
          rules={[{ required: true, message: "Введите название" }]}
        >
          <Input placeholder="Например: Начисление бонусов за акцию" />
        </StyledFormItem>

        <StyledFormItem
          label="Тип идентификатора в файле"
          name="lookup_type"
          initialValue="phone"
          rules={[{ required: true }]}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="phone">Телефон</Radio.Button>
            <Radio.Button value="guid">GUID</Radio.Button>
          </Radio.Group>
        </StyledFormItem>

        <StyledFormItem
          label="Количество баллов"
          name="amount"
          rules={[{ required: true, message: "Введите количество" }]}
        >
          <InputNumber
            min={1}
            style={{ width: "100%" }}
            placeholder="100"
          />
        </StyledFormItem>

        <StyledFormItem
          label="CSV файл"
          name="file"
          rules={[{ required: true, message: "Загрузите файл" }]}
        >
          <Upload
            beforeUpload={() => false}
            maxCount={1}
            accept=".csv,.txt"
          >
            <Button icon={<UploadOutlined />}>Выбрать файл</Button>
          </Upload>
        </StyledFormItem>

        <HintText>
          Файл должен содержать по одному телефону или GUID на каждой строке.
        </HintText>

        <ButtonRow>
          <ButtonCol>
            <Button onClick={onClose} icon={<CloseSvg />}>
              Закрыть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button
              icon={<SaveSvg />}
              type="primary"
              htmlType="submit"
              loading={isSubmitting}
            >
              Создать и запустить
            </Button>
          </ButtonCol>
        </ButtonRow>
      </FormEdit>
    </DrawerEdit>
  )
}

const DrawerEdit = styled(Drawer)``
const FormEdit = styled(Form)``
const StyledFormItem = styled(Form.Item)`margin-bottom: 16px;`
const ButtonCol = styled(Col)`padding-bottom: 5px;`
const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
  .ant-col { margin-left: 0.4em; }
`
const HintText = styled.div`
  color: #888;
  font-size: 12px;
  margin-bottom: 16px;
`
